
//上传图片列表
<template>
  <div>
    <div class="mycamera mycameralist" v-for="(item,index) in uploadList" :key="index">
      <template v-if="item.status === 'finished'">
        <img :src="port+item.url">
        <div class="demo-upload-list-cover">
          <Icon type="ios-trash-outline" size="50" @click.native="handleRemove(item)"></Icon>
        </div>
      </template>
      <template v-else>
        <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
      </template>
    </div>
    <!-- <div style="display:inline-block" @click="changeLoad"> -->
    <Upload
      class="mycamera mycameralist"
      ref="upload"
      :name="'Image'"
      :show-upload-list="false"
      :default-file-list="defaultList"
      :format="['jpg','jpeg','png']"
      :before-upload="handleBeforeUpload"
      :on-format-error="handleFormatError"
      :on-success="handleSuccess"
      type="drag"
      :action="port+'api/public/Upload/UploadImage/'"
    >
      <div class="icon-box">
        <Icon type="ios-camera" size="50"></Icon>
      </div>
    </Upload>
    <!-- <div class="load" v-if="isLoad">
      正在扫描文件
      <img src="../assets/imgs/load.gif" alt>
    </div>-->
    <!-- </div> -->
  </div>
</template>

<script>
import * as homeConst from "../apiconfig/index.js";
import * as homeApi from "../api/teacher-api.js";
import * as allFn from "../utils/index.js";
export default {
  name: "myUploadList",
  props: ["defaultList"],
  data() {
    return {
      port: homeConst.baseUrl + "/",
      uploadList: [],
      isLoad: false
    };
  },
  created() {},
  mounted() {
    this.uploadList = this.$refs.upload.fileList;
  },
  watch: {},
  methods: {
    // 删除
    handleRemove(file) {
      const fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
    },
    // 判断文件格式是否正确
    handleFormatError(file) {
      this.isLoad = false;
      this.$Message.error({
        content: file.name + "文件格式不正确",
        duration: 3
      });
    },

    // 上传列表
    handleSuccess(res, file) {
      this.isLoad = false;
      file.url = res.msg;
      this.$emit("getUrlListArr", this.uploadList);
    },
    // 轮播图最多可以上传几张
    handleBeforeUpload() {
      const check = this.uploadList.length < 5;
      if (!check) {
        this.$Message.error({
          content: "文件数量超出范围",
          duration: 3
        });
      }
      return check;
    }
    // changeLoad() {
    //   var _that = this;
    //   this.uploadList = this.$refs.upload.fileList;
    //   setTimeout(function() {
    //     _that.isLoad = true;
    //   }, 1000);
    // }
  }
};
</script>

<style>
</style>